import Select from "../../../../design-system/components/Select/Select.jsx";
import styles from "../showroomForm.css";

/**
 * Component representing a form selection input.
 * Handles rendering a dropdown selection with label, validation, and state management.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.fieldKey - The key representing the field in the form data object.
 * @param {string} props.label - The label to be displayed for the selection input.
 * @param {string} props.description - The descriptiion to be displayed for the selection input.
 * @param {Object} props.formData - The form data object containing the state for all fields.
 * @param {Function} props.setFormData - Function to update the form data object.
 * @param {Array} props.options - The options to display within the selection dropdown.
 * @param {boolean} props.required - Indicates whether the selection is mandatory.
 * @param {Function} props.validate - Function to validate the input value.
 * @param {string | null} props.error - An error message to display if validation fails.
 * @returns {JSX.Element} Returns a dropdown selection component.
 */
export const SingleSelection = ({
  fieldKey,
  label,
  description,
  formData,
  setFormData,
  options,
  required,
  validate,
  error,
}) => {
  return (
    <div className={styles.formGroup}>
      {label && (
        <h2>
          {label}
          {required && "*"}
        </h2>
      )}
      {description && <p className={styles.description}>{description}</p>}
      <Select
        name={fieldKey}
        label={label}
        selected={formData[fieldKey]?.data ?? ""}
        onChange={(e) => {
          validate(e);
          setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldKey]: { ...prevFormData[fieldKey], data: e.target.value },
          }));
        }}
        options={options}
        required={required}
        error={error}
        theme={"dark"}
      />
    </div>
  );
};
